'use strict';
export { createAnimatedComponent } from './createAnimatedComponent';
